<template>
	<div class="oper-group-manage-root pa-0 d-flex flex-column">
		<div flat class="flex-grow-0 flex-shrink-0  mt-2 d-flex flex-row flex-wrap">
			<v-btn
				rounded
				class="ml-2 mb-2" 
				@click="refreshClicked" 
				color="primary"
				:disabled="refreshDisabled"
							
			>	
				<v-icon>mdi-file-find</v-icon>
				刷新操作员组
			</v-btn>
			<v-btn
				
				class="ml-2 mb-2 left-round white--text" 
				color="blue-grey"
				:disabled="addGroupDisabled"
			>
				<span><v-icon>mdi-file-outline</v-icon></span>      
				增加操作员组
			</v-btn>
			<v-btn
				class="ml-1 mb-2 right-round white--text" 
				color="blue-grey"
				:disabled="editGroupDisabled"
				
			>
				<span><v-icon>mdi-notebook-edit-outline</v-icon></span>      
				编辑操作员组
			</v-btn>
			<v-btn
				class="ml-2 mb-2 left-round" 
				color="warning"
				@click="viewPriviledgeClicked" 
				:disabled="viewPriviledgeDisabled"
				
			>
				<span><v-icon>mdi-notebook-edit-outline</v-icon></span>                
				查看权限                
			</v-btn>
			<v-btn
				class="ml-1 mb-2 right-round" 
				color="warning"
				@click="backClicked"
				:disabled="backDisabled"
				
			>
				<span><v-icon>mdi-backup-restore</v-icon></span>                
				返回                
			</v-btn>			  
			<v-btn				
				class="ml-2 mb-2 left-round" 
				color="primary"
				:disabled="editMenuPriviledgeDisabled"
				@click="handleEditMenuPriviledgeFunc" 
			>
				<span><v-icon>mdi-notebook-edit-outline</v-icon></span>                
				编辑菜单权限                
			</v-btn>
			<v-btn
				class="ml-1 mb-2 mr-2 right-round" 
				color="primary"
				@click="handleEditDeptPriviledgeFunc" 
				:disabled="editDeptPriviledgeDisabled"
				
			>
				<span><v-icon>mdi-notebook-edit-outline</v-icon></span>      
				编辑数据权限
			</v-btn>
			
		</div>
		<div class="flex-grow-1 flex-shrink-1" style="position:relative;">
			<div style="position:absolute;top:0;bottom:0;left:0;right:0;" class="pa-1">
				<div v-show="pageNo==1" class="pa-0 ma-0"  style="width:100%;height:100%;">
					<v-data-table
						:headers="headers"						
						fixed-header
						:items="operGroups"		   
						class="elevation-1 oper-group-table"
						disable-pagination
						hide-default-footer
						height="100%"
						width="100%"
						single-select
						show-select
						item-key="operGroupId"
						v-model="selectedOperGroup"
                        style="width:100%;height:100%;"
						>
						</v-data-table>
				</div>
				<div v-show="pageNo==2" class="pa-0 ma-0" style="width:100%;height:100%;">
                    <div class="d-flex flex-column" style="width:100%;height:100%;"> 
                        <div class="flex-grow-0 flex-shrink-0 pt-3 py-1 ma-0">
                            <div class="py-0 d-flex flex-row">
                                <div class="form-item form-item-width-1 py-0 ma-0">
                                    <label class="form-item-label py-0 mt-0 mr-0">操作员组编号:</label>
                                    <v-text-field 
                                        class="form-item-value py-0" 								
                                        outlined
                                        dense
                                        placeholder=""
                                        readonly
                                        :value="selectedOperGroup[0]?selectedOperGroup[0].operGroupId:''"
                                    >
                                    </v-text-field>						
                                </div>
                                <div class="form-item form-item-width-2 py-0  ma-0">
                                    <label class="form-item-label py-0 mt-0 mr-0">操作员组名称:</label>
                                    <v-text-field 
                                        class="form-item-value  py-0" 
                                        outlined						
                                        dense
                                        placeholder=""
                                        readonly
                                        :value="selectedOperGroup[0]?selectedOperGroup[0].operGroupName:''"
                                    >
                                    </v-text-field>						
                                </div>
                            </div>
                                                    
                            <div class="py-1 d-flex flex-row">
                                <div class="py-0 ma-0 form-item form-item-width-3">
                                    <label class="form-item-label py-0 mt-0 mr-0">请选择APP:</label>
                                    <div class="form-item-value">
                                        <v-select
                                            v-model="selectedApp"
                                            :items="apps"						
                                            label=""
                                            hide-details											
                                            flat
                                            solo
                                            outlined
                                            dense						
                                            return-object
                                            item-text="caption"
                                            full-width	
                                            :disabled="selectAppDisabled"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                                <div>
                                    <v-btn
                                        rounded
                                        class="ml-1 mb-0 mr-1 left-round" 
                                        color="success"
                                        @click="handleSaveFunc" 
                                        :disabled="savePriviledgeDisabled"
                                    >
                                        <span><v-icon>mdi-content-save</v-icon></span>      
                                        保存
                                    </v-btn>
                                    
                                    <v-btn
                                        rounded
                                        class="ml-0 mb-0 mr-2 right-round" 
                                        color="blue-grey"
                                        @click="handleCancelFunc" 
                                        :disabled="savePriviledgeDisabled"
                                    >
                                        <span><v-icon>mdi-cancel</v-icon></span>      
                                        取消
                                    </v-btn>
                                </div>
                            </div>
                        </div>

                        <div class="flex-grow-1 flex-shrink-1 pa-0 ma-0">
                            <div class="d-flex flex-column  tabPane-root">
                                <div class="flex-grow-0 flex-shrink-0 px-1">
                                    <v-tabs
                                        background-color="transparent"		    
                                        left
                                        show-arrows			
                                        slider-color="transparent"
                                        slider-size=0
                                        v-model="selectedTabId"
                                    >									
                                        <!--v-tab
                                            v-for="item in tabs"
                                            :key="item.tabId"
                                            active-class="active-tab"
                                            :href="'#'+item.tabId"
                                        >										
                                            {{ item.title }}
                                        </v-tab -->
                                        
                                        <v-tab										
                                            :key="tabs[0].tabId"
                                            active-class="active-tab"
                                            :href="'#'+tabs[0].tabId"										
                                            :disabled="menuAuthTabDisabled"
                                        >										
                                            {{ tabs[0].title }}
                                        </v-tab>
                                        
                                        <v-tab
                                            :key="tabs[1].tabId"
                                            active-class="active-tab"
                                            :href="'#'+tabs[1].tabId"									
                                            :disabled="deptAuthTabDisabled"
                                        >										
                                            {{ tabs[1].title }}
                                        </v-tab>
                                    </v-tabs>	
                                </div>
                                
                                <div class="flex-grow-1 flex-shrink-1 pa-0 v-tabitem-group" style="position:relative;">
                                    <div style="position:absolute;top:0;bottom:0;left:0;right:0;">									
                                        <div class="ma-0 pa-0"  style="position:relative;width:100%;height:100%;max-width:100%;max-height:100%" >
                                            <v-tabs-items v-model="selectedTabId" class="active-tab-view">
                                                <v-tab-item												
                                                    :key="tabs[0].tabId"	
                                                    :value="tabs[0].tabId"	
                                                    active-class="active-tab-view"		
                                                    eager												
                                                >																							
                                                    <menu-auth-table class="tabView-comp pl-1 pt-1" ref="menuAuthTable"
                                                      style="width:100%;height:100%;"
                                                      width="100%"
                                                      height="100%"
                                                    ></menu-auth-table>
                                                </v-tab-item>
                                                
                                                <v-tab-item
                                                    :key="tabs[1].tabId"	
                                                    :value="tabs[1].tabId"	
                                                    active-class="active-tab-view"
                                                    eager												
                                                >											
                                                    <dept-auth-table class="tabView-comp pl-1 pt-1" ref="deptAuthTable"
                                                      style="width:100%;height:100%;"
                                                    ></dept-auth-table>
                                                </v-tab-item>
                                                
                                            </v-tabs-items>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>	
				
			</div>
		</div>
	</div>
	
</template> 

<script>
	import {default as OperGroupApi} from "../../../../api/smp/sys/OperGroupApi.js";
	import {default as ModuleApi} from "../../../../api/smp/sys/ModuleApi.js";
	import {default as ModuleFunctionApi} from "../../../../api/smp/sys/ModuleFunctionApi.js";
	import {default as AppApi} from "../../../../api/smp/sys/AppApi.js";
	import MenuAuthTable from './MenuAuthTable.vue';
	import DeptAuthTable from './DeptAuthTable.vue';
	import {default as AuthManageApi} from "../../../../api/smp/sys/AuthManageApi.js";
	
	export default {
		name: 'Smp-Oper-Group-Manage', 
		components: {
			'menu-auth-table':MenuAuthTable,
			'dept-auth-table':DeptAuthTable
		},
		data: () => ({
			headers:[				
				{text: '编号',align: 'start',sortable: false,value: 'operGroupId',width:80,divider:true},
				{ text: '名称', value: 'operGroupName',sortable: false ,width:600,divider:true},				
                { text: '状态', value: 'statusName',sortable: false ,width:100,divider:true},
                { text: '', value: '',sortable: false ,divider:true},
			],
			operGroups:[],
			selectedOperGroup:[],
			pageNo:1,    //1操作员组列表 2 操作员组权限
			selectedTabId:null,
			tabs:[{tabId:'tab-1',title:'菜单权限'},{tabId:'tab-2',title:'数据权限'}],
			
			apps:[],
			selectedApp:null,
						
			editingMenuPriviledge:false,
			editingDeptPriviledge:false,
		}),
		methods:{
			refreshClicked(){
				this.loadOperGroups();
			},
			viewPriviledgeClicked(){
				this.pageNo = 2;
				this.selectedApp = null;
				this.editing = false;
				this.loadOperGroupDeptsAndPriviledge();
			},
			backClicked(){
				this.pageNo=1;
                this.selectedApp=null;
			},
			handleSaveFunc(){
				let me = this;
				let selectedMenus = this.$refs.menuAuthTable.getSelectedMenus();
				let selectedDepts = this.$refs.deptAuthTable.getSelectedDepts();
				
				//菜单功能只获取末级
				let menus = [];
				selectedMenus.forEach(function(item){
					if(item && item.lower && item.lower.length && item.lower.length>0)
						return;
					else
						menus.push(item);
				});
				
				//部门只获取高级
				let depts = [];
				let map = new Map();
				selectedDepts.forEach(function(item){
					map.set(item.code,item);
				});
				
				selectedDepts.forEach(function(item){
					let lengthPerLevel = 5;
					if(me.parentDeptExists(map,item.code))
						return;
					else
						depts.push(item);
				});
				
				let operGroup = this.selectedOperGroup[0];
				
				/*
				console.log('saving priviledge');
				console.log('group->');
				console.log(operGroup);
				console.log('dept->');
				console.log(depts);
				console.log('menu->');
				console.log(menus);
				*/
				
				//执行保存权限
				if(this.editingMenuPriviledge===true){
					this.saveMenuPrivilege(operGroup.operGroupId,this.selectedApp.appId,menus);
				}
				if(this.editingDeptPriviledge===true){
					this.saveDeptPrivilege(operGroup.operGroupId,depts);
				}
			},
			parentDeptExists(map,deptCode){
				let me = this;
				let lengthPerLevel = 5;
				if(deptCode.length<=1*lengthPerLevel)
					return false;
				let parentCode=deptCode.substr(0,deptCode.length-1*lengthPerLevel);
				let parentDept = null;
				parentDept = map.get(parentCode);
				if(parentDept)
					return true;
				else{
					return me.parentDeptExists(map,parentCode);
				}	
			},
			async saveMenuPrivilege(operGroupId,appId,menus){
				let me = this;
				//dto准备
				let simMenus = [];
				menus.forEach(function(item){
					simMenus.push({id:item.id});
				});
				
				try{
					let resp = await AuthManageApi.updateOperGroupPreviledgeMenu(operGroupId,appId,simMenus);
					console.log("save oper group menu priviledge returned:");
					console.log(resp);
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'修改操作员组菜单权限失败':msg;
						throw new Error(msg);
						return;
					}
					
					//await me.loadOperGroupMenusAndPriviledge();
					await me.errMsg('成功','菜单权限已保存');
					me.resetPriviledgeBrowsingState();
				}catch(err){
					me.errMsg('错误','修改操作员组菜单权限失败:'+err.message);
				};
			},
			async saveDeptPrivilege(operGroupId,depts){
				let me = this;
				//dto准备
				let simDepts = [];
				depts.forEach(function(item){
					simDepts.push({id:item.id});
				});
				
				try{
					let resp = await AuthManageApi.updateOperGroupPreviledgeDept(operGroupId,simDepts);
					console.log("save oper group dept priviledge returned:");
					console.log(resp);
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'修改操作员组部门权限失败':msg;
						throw new Error(msg);
						return;
					}
					
					//await me.loadOperGroupDeptsAndPriviledge();
					await me.errMsg('成功','部门权限已保存');
					me.resetPriviledgeBrowsingState();
				}catch(err){
					me.errMsg('错误','修改操作员组部门权限失败:'+err.message);
				};
			},
			
			handleEditMenuPriviledgeFunc(){
				this.editingMenuPriviledge = true;
				this.$refs.menuAuthTable.setEditing(true);
				this.$refs.deptAuthTable.setEditing(false);
				
				this.selectedTabId = this.tabs[0].tabId;
				this.editingDeptPriviledge = false;
			},
			handleEditDeptPriviledgeFunc(){
				this.editingDeptPriviledge = true;
				this.$refs.deptAuthTable.setEditing(true);
				this.$refs.menuAuthTable.setEditing(false);
				
				this.selectedTabId = this.tabs[1].tabId;
				this.editingMenuPriviledge = false;
			},
			handleCancelFunc(){
				this.resetPriviledgeBrowsingState();
			},
			resetPriviledgeBrowsingState(){
				//数据清理
				if(this.editingMenuPriviledge==true){
					this.loadOperGroupMenusAndPriviledge();
					this.selectedTabId = this.tabs[0].tabId;
				}
				if(this.editingDeptPriviledge==true){
					this.loadOperGroupDeptsAndPriviledge();
					this.selectedTabId = this.tabs[1].tabId;
				}
				
				this.editingMenuPriviledge = false;
				this.editingDeptPriviledge = false;
				
				this.$refs.menuAuthTable.setEditing(false);
				this.$refs.deptAuthTable.setEditing(false);
				
				
			},
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			async loadOperGroupDeptsAndPriviledge(){
				let me = this;
				
				try{
					await me.$refs.deptAuthTable.loadDepts();
				}catch(err){
					console.log(err);
					me.errMsg('错误','获取部门信息失败:'+err.message);
					return;
				}
				
				try{
					await me.$refs.deptAuthTable.loadOperGroupPriviledgeDept(me.selectedOperGroup[0].operGroupId);
				}catch(err){
					console.log(err);
					me.errMsg('错误','获取部门权限信息失败:'+err.message);
					return;
				}
			},
			async loadOperGroupMenusAndPriviledge(){
				let me = this;
				if(!this.selectedApp){
                    //清理表格
                     this.$refs.menuAuthTable.clear();
					return;
                }
					
				let appId = this.selectedApp.appId;
				try{
					await me.$refs.menuAuthTable.loadMenus(appId);
				}catch(err){
					me.errMsg('错误','获取菜单信息失败:'+err.message);
					return;
				}
				if(!me.selectedOperGroup || !me.selectedOperGroup[0]){
					me.errMsg("未找到选择的操作员组");
					return;
				}
				try{
					await this.$refs.menuAuthTable.loadOperGroupPriviledgeMenuLeafAndButton(appId,me.selectedOperGroup[0].operGroupId);
				}catch(err){
					me.errMsg('错误','获取和设置菜单权限信息失败:'+err.message);
					return;
				}
			},
			loadOperGroups(){
				let me = this;
				OperGroupApi.queryAllOperGroup().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取操作员组信息失败':msg;
						throw new Error(msg);
						return;
					}
					
					let operGroups = data.data.operGroups;
					//修改类型名
					operGroups.forEach(function(group){
						if(group.status==1)
						  group.statusName="有效";
						else
						  group.statusName="其他";						
					});
					me.operGroups = operGroups;
				}).catch(function(err){
					me.errMsg('错误','获取操作员组信息失败:'+err.message);
				});
			},
			loadApps(){
				let me = this;
				AppApi.queryAllApp().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取APP信息失败':msg;
						throw new Error(msg);
						return;
					}					
					
					let apps = data.data.apps;
					//修改类型名
					apps.forEach(function(app){
						app.caption=app.appId+"-"+app.appCode+"-"+app.appName;
					});
					me.apps = apps;
				}).catch(function(err){
					me.errMsg('错误','获取APP信息失败:'+err.message);
				});
			},
			
		},
		computed:{	
			refreshDisabled(){
				return (!(this.pageNo==1));
			},
			addGroupDisabled(){
				return (!(this.pageNo==1));
			},
			editGroupDisabled(){
				let disabled= ((!(this.pageNo==1)) || 
					(this.selectedOperGroup==null)||
					((this.selectedOperGroup instanceof Array) && (this.selectedOperGroup.length<1 ))
					);
				return disabled;
			},
			viewPriviledgeDisabled(){
				return (this.pageNo!=1) ||
					(this.selectedOperGroup==null)||
					((this.selectedOperGroup instanceof Array) && (this.selectedOperGroup.length<1 ));
			},
			backDisabled(){
				return ((!(this.pageNo==2))
				||(this.editingMenuPriviledge==true)
				||(this.editingModuleFuncPriviledge==true)
				||(this.editingDeptPriviledge==true));
			},
			editMenuPriviledgeDisabled(){
				return ((!(this.pageNo==2)) ||(!this.selectedApp)
				||(this.editingMenuPriviledge==true)
				||(this.editingModuleFuncPriviledge==true)
				||(this.editingDeptPriviledge==true));
			},
			editDeptPriviledgeDisabled(){
				return ((!(this.pageNo==2))
				||(this.editingMenuPriviledge==true)
				||(this.editingModuleFuncPriviledge==true)
				||(this.editingDeptPriviledge==true));
			},
			savePriviledgeDisabled(){
				return (!(this.pageNo==2)) || (!((this.editingMenuPriviledge==true)
				||(this.editingModuleFuncPriviledge==true)
				||(this.editingDeptPriviledge==true)));
			},
			deptAuthTabDisabled(){
				return this.editingMenuPriviledge==true;
			},
			menuAuthTabDisabled(){
				return this.editingDeptPriviledge==true;
			},
			selectAppDisabled(){
				return (this.editingDeptPriviledge==true)
				||(this.editingMenuPriviledge==true);
			},

		},		
		created(){
			this.loadOperGroups();
			this.loadApps();
		},
		watch:{
			async selectedApp(newSelectApp){
				this.loadOperGroupMenusAndPriviledge();												
			}
		}
	}
</script>

<style scoped>
	.oper-group-manage-root{
		max-width:100%;
		max-height:100%;
		width:100%;
		height:100%;
	}
	.oper-group-table{		
		width:100%;
		height:100%;
		max-width:100%;
		max-height:100%;	   
	}
	.maxed{
		width:100%;
		height:100%;
		max-width:100%;
		max-height:100%;	   
	}
	.active-tab-view{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
	}
	
	.tabPane-root{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
	}
	
	.tabView-comp{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
	}
	
	.oper-group-manage-root .active-tab{
		background-color:lightblue;		
	}

    .v-tabitem-group {
		border-top:2px solid lightblue;
		padding-top: 10px;
	}
</style>
